
<template>
  <div class="add_school">
    <div class="home_head">
      <div class="home_main">
        <div class="home_main_title">新增院校</div>
        <div style="text-align:center;">
          <input type="text" class="school_input" v-model="newSchoolName" />
        </div>
        <div
          style="display:flex;height:4rem;line-height:3rem;text-align:center;justify-content: space-around;"
        >
          <span class="primary_btn" @click="reslt()">确定</span>
          <span class="cancel_btn" @click="concelCommit()">取消</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import user_service from "@/service/user_service";
export default {
  data() {
    return {
      newSchoolName: ""
    };
  },
  created(){
    // console.log(this.$route)
    this.newSchoolName = this.$route.query.school||'';
  },
  methods: {
    reslt() {
      this.$router.push("/info?addName=" + this.newSchoolName);
    },
    concelCommit(){
       this.$router.push("/info");
    }
  }
};
</script>
    <style scoped>
.add_school {
  height: 100%;
  width: 100%;
}
.home_head {
  width: 100%;
  height: 40vh;
  background: linear-gradient(90deg, #319cc4 0%, #317bd2 50%, #6471d0 100%);
  position: relative;
}
.home_main {
  position: absolute;
  top: 7vh;
  left: 3vw;
  right: 3vw;
  background: #ffffff;
  min-height: 15rem;
  border-radius: 6px;
  padding-top: 2rem;
  padding-left: 5%;
  padding-right: 5%;
  padding-bottom: 3rem;
}
.home_main_title {
  text-align: center;
  font-size: 1.8rem;
  font-weight: bold;
  color: #333333;
}
.primary_btn {
  color: #ffffff;
  background: #009bfe;
  border-radius: 2rem;
  padding: 0.5rem 3rem;
  font-size: 1.2rem;
}
.cancel_btn {
  color: #ffffff;
  background: #cccccc;
  border-radius: 2rem;
  padding: 0.5rem 3rem;
  font-size: 1.2rem;
}
.home_main div {
  margin-top: 3rem;
}
.school_input {
  width: 80%;
  height: 3rem;
  background: #ffffff;
  border: 1px solid #cccccc;
  border-radius: 44px;
  font-size: 1.5rem;
  color: #555555;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/add_school.vue